import React from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";

const MasterFoodLibraryCard = () => {
  const { t } = useTranslation("coaching-portal");

  const items = [
    {
      id: "custom-food",
      icon: "/img/new-icons/meal.svg",
      title: t("allTemplates.chooseASection.masterFoodLibrary.customFood.title"),
      description: t(
        "allTemplates.chooseASection.masterFoodLibrary.customFood.description"
      ),
      href: "/coaching-portal/master-food-library",
    },
    {
      id: "create-meal",
      icon: "/img/new-icons/food.svg",
      title: t("allTemplates.chooseASection.masterFoodLibrary.createMeal.title"),
      description: t(
        "allTemplates.chooseASection.masterFoodLibrary.createMeal.description"
      ),
      href: "/coaching-portal/master-food-library?section=meal",
    },
    {
      id: "external-food",
      icon: "/img/new-icons/search.svg",
      title: t(
        "allTemplates.chooseASection.masterFoodLibrary.externalFood.title"
      ),
      description: t(
        "allTemplates.chooseASection.masterFoodLibrary.externalFood.description"
      ),
      href: "/coaching-portal/master-food-library?section=external",
    },
  ];

  return (
    <div className="master-food-library-card flex-1 min-w-[20rem] rounded-2xl p-4 flex flex-col gap-4">
      <div className="master-food-library-card-header">
        <h3 className="text-2xl font-bold">
          {t("allTemplates.chooseASection.masterFoodLibrary.title")}
        </h3>
        <p className="p4 opacity-50 mt-1">
          {t("allTemplates.chooseASection.masterFoodLibrary.description")}
        </p>
      </div>
      {items.map((item) => (
        <a
          key={item.id}
          href={item.href}
          className="master-food-library-card-item rounded-xl bg-(--white-05) p-4"
        >
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-1">
              <SvgIcon
                src={item.icon}
                useCurrentColor
                classNames="master-food-library-card-item-icon"
              />
              <p className="font-semibold">{item.title}</p>
            </div>
            <SvgIcon
              src="/img/new-icons/arrow-right.svg"
              classNames="master-food-library-card-item-arrow"
            />
          </div>
          <p className="p5 opacity-70 pt-2">{item.description}</p>
        </a>
      ))}
    </div>
  );
};

export default MasterFoodLibraryCard;
